export default __webpack_public_path__ + "static/media/tick.7defcee0.svg";